import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbComponent } from '@abp/ng.theme.shared';
import { Router } from '@angular/router';
import { RouterEvents, RoutesService, SubscriptionService } from '@abp/ng.core';
import { HealthCheckService } from '../shared/services/health-check-service';
import { Subscription } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  standalone: false,
  selector: 'abp-breadcrumb',
  templateUrl: './custom-breadcrumb.component.html',
  styleUrl: './custom-breadcrumb.component.scss'
})
export class CustomBreadcrumbComponent extends BreadcrumbComponent implements OnInit, OnDestroy {
  private healthCheckSubscription: Subscription;
  isOnline = true;

  constructor(
    private readonly healthCheckService: HealthCheckService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.checkConnectionStatus();
  }

  checkConnectionStatus() {
    this.healthCheckSubscription = this.healthCheckService.heartBeat$.subscribe(isHealthy => {
      this.isOnline = isHealthy;
    });
  }

  ngOnDestroy(): void {
    if (this.healthCheckSubscription) {
      this.healthCheckSubscription.unsubscribe();
    }
  }
}
